import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

type NavRowProps = {
	text: string;
	leftSlot?: React.ReactNode;
	rightSlot?: React.ReactNode;
	size?: 'default' | 'collapsed';
	disabled?: boolean;
	className?: string;
};

const NavRow = ({
	text,
	leftSlot,
	rightSlot,
	size = 'default',
	disabled = false,
	className,
}: NavRowProps) => {
	return (
		<div
			className={twMerge(
				clsx(
					'flex items-center select-none',
					disabled ? 'cursor-not-allowed text-tertiary' : 'text-secondary',
					size === 'default' && 'px-3 py-2 gap-2',
					size === 'collapsed' && 'justify-center items-center w-full h-full',
					className,
				),
			)}
		>
			{leftSlot && <div className='h-4 w-4 shrink-0 text-icon-secondary'>{leftSlot}</div>}
			{size === 'default' && (
				<>
					<div className='min-w-0 first-letter:uppercase truncate'>{text}</div>
					<div className='flex-1' />
					{rightSlot && (
						<div className='h-4 w-4 shrink-0 flex items-center justify-center'>{rightSlot}</div>
					)}
				</>
			)}
		</div>
	);
};

export default NavRow;
